import { render, staticRenderFns } from "./Gene.vue?vue&type=template&id=12e615b9&scoped=true"
import script from "./Gene.vue?vue&type=script&lang=js"
export * from "./Gene.vue?vue&type=script&lang=js"
import style0 from "./Gene.vue?vue&type=style&index=0&id=12e615b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e615b9",
  null
  
)

export default component.exports